import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage} from "../../../PanelPage";
import {LoginWithEmailCode} from "../../../../website/unauthenticated/slides/LoginWithEmailCodeForm";
import {Messages} from "../../../../Messages";
import {Router} from "../../../../../stem-core/src/ui/Router";
import {MessageElement} from "../../../../widget/ui/MessageElement";
import {authFormService} from "../../../../services/AuthFormService";
import {userService} from "../../../../../client/connection/services/UserService";
import {LoadingSpinner} from "../../../../../core/ui/LoadingSpinner.jsx";
import {apiConfirmUserEmailChange} from "../../../../../client/state/UserProfileStore";
import {DefaultCodeConfirmationForm} from "../../../../common/DefaultCodeConfirmationForm";
import {INLINE_USER_DASHBOARD_URLS} from "../../../PanelConstants";
import {Toast} from "../../../../ui/Toast.jsx";


class InlineUserDashboardChangeEmailCodeConfirmationComponent extends LoginWithEmailCode {
    canDisplayResendCodeOption = false;

    getEmailConfirmationFormClass() {
        return DefaultCodeConfirmationForm;
    }

    getBeforeInput() {
        return [
            <div className={this.styleSheet.title}>{Messages.confirmEmailChangeModalTitle}</div>,
            <div className={this.styleSheet.text}><MessageElement message={Messages.confirmEmailChangeLine1} args={[authFormService.changeToEmailAddress]}/></div>,
            <div className={this.styleSheet.text}><MessageElement message={Messages.confirmEmailChangeLine2} args={[authFormService.changeToEmailAddress, userService.getUserEmail()]}/></div>,
        ];
    }

    async handleSubmit(code) {
        LoadingSpinner.show();
        try {
            await apiConfirmUserEmailChange({code});
            Toast.showSuccess(Messages.emailSuccessfullyChanged);
        } catch (error) {
            Toast.showError(error, Messages.errorWhileSaving);
        } finally {
            LoadingSpinner.hide();
        }
        Router.changeURL(INLINE_USER_DASHBOARD_URLS.home);
    }
}

export class InlineUserDashboardChangeEmailCodeConfirmPanel extends BasePanelPage {
    render() {
        return <InlineUserDashboardChangeEmailCodeConfirmationComponent />;
    }
}
